// extracted by mini-css-extract-plugin
export default {"version":"Versions_version__hBdfH","input":"Versions_input__3O3fV"};